import React from 'react';

import CustomTooltip, { POSITIONS } from '@components/CustomTooltip';

import { getShortName } from '@utils/Util';

const DropdownWrapper = ({ children, label, isEditEnabled, readOnlyText, showTooltip = false }) => {
	return (
		<div className={`style-single mb-2`}>
			<div className="label-and-info d-flex align-items-center ">
				<div className="label mr-2">
					<p className="regular-12 weight-500 gray_dark_02">{label}</p>
				</div>
				<div className="form-group mb-0">
					{isEditEnabled ? (
						children
					) : (
						<div className="click-box click mb-1">
							{showTooltip ? (
								<CustomTooltip
									arrowCenter={true}
									position={POSITIONS.TOP}
									text={readOnlyText}
								>
									{getShortName(readOnlyText, 15)}
								</CustomTooltip>
							) : (
								<p>{readOnlyText}</p>
							)}
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default DropdownWrapper;
